// extracted by mini-css-extract-plugin
export default {"fileDraggerDisabled":"fileDraggerDisabled__XnYnzn","filesUpload":"filesUpload___TJ_tw","orDivider":"orDivider__Sui2xI","mediaOriginsView":"mediaOriginsView__q7hYuV"};